/* eslint-disable no-param-reassign */
import Store from '@/Plugins/Store';

Store.registerModule('ui', {
  namespaced: true,
  state: {
    mainMenuOpened: false,
  },
  mutations: {
    setMainMenuOpened(state, param) {
      state.mainMenuOpened = param;
    },
  },
  getters: {
    mainMenuOpened(state) {
      return state.mainMenuOpened;
    },
  },
});
